/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";

const Wrapper = styled.div(
  {
    position: "absolute",
    overflow: "hidden",
    display: "inline-flex",
    flexWrap: "nowrap",
    justifyContent: "space-between",

    "& > i ": {
      marginRight: ".6rem",
      fontSize: "2rem",
      width: "2rem",
      color: "#ffd010",
    },
  },
  (props) => ({
    width: props.width || "100%",
  })
);

const Rating = ({ rate }) => {
  return (
    <div css={{ position: "relative", width: "13rem", height: "2.5rem" }}>
      <Wrapper css={{ width: `${(rate / 5) * 100}%` }}>
        <i className="fas fa-star"></i>
        <i className="fas fa-star"></i>
        <i className="fas fa-star"></i>
        <i className="fas fa-star"></i>
        <i className="fas fa-star"></i>
      </Wrapper>
      <Wrapper>
        <i className="far fa-star"></i>
        <i className="far fa-star"></i>
        <i className="far fa-star"></i>
        <i className="far fa-star"></i>
        <i className="far fa-star"></i>
      </Wrapper>
    </div>
  );
};

export default Rating;
